export default __webpack_public_path__ + "static/media/16.848711b6.jpg";